import { Driver } from '../interfaces'

export const useCourierLocation = (driver?: Driver) => {
    const { latitude, longitude } = driver ?? {}
    const courierLocation =
        latitude && longitude
            ? {
                  latitude: parseInt(latitude, 10),
                  longitude: parseInt(longitude, 10),
              }
            : undefined

    return courierLocation
}
